// @ts-strict-ignore
import React, {FC, ReactNode} from 'react';
import {Typography} from 'onboarding-components';

import styles from './tile-button-bar.module.styl';

interface ButtonBarProps {
  heading: string;
  children: ReactNode;
  className?: string;
}

export const ButtonBar: FC<ButtonBarProps> = ({heading, children, className}) => (
  <div className={`${styles.buttonBar} ${className || ``}`}>
    <Typography className={styles.buttonBarTitle} variant='headingXs'>
      {heading}
    </Typography>
    <div className={styles.buttonBarActions}>{children}</div>
  </div>
);
